export const thousandSeparator = (value: number | string) => {
  const string = value.toString()
  return string.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
